import styled from 'styled-components';
import { Colors } from 'axl-reactjs-ui';

export const Panel = styled.div`
  justify-content: center;
  align-items: center;
  flex-direction: column;
  display: flex;
  height: 100%;
`;
export const PanelTop = styled.div`
  padding: 10px 20px;
  height: auto;
  box-sizing: border-box;
  width: 100%;
  background-color: ${Colors.dustyRed};
`;
export const PanelMain = styled.div`
  flex: 1;
  width: 100%;
`;
export const PanelBottom = styled.div`
  position: relative;
  height: 38px;
  width: 100%;
`;
export const TextError = styled.div`
  font-family: AvenirNext;
  font-size: 13px;
  color: #ffffff;
`;

export const Footer = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 50px;
  box-sizing: border-box;
  padding: 4px 10px 4px 10px;
  background-color: ${Colors.veryLightGrey};
  display: flex;
  flex-direction: row;
  justify0content: space-around;
  align-items: center;
  zIndex: 1;
`;

export const groupButtons = styled.div`
  min-width: 85px;
`;

export default {
    container: {
        paddingBottom: '50px',
        textAlign: 'left',
        position: 'relative',
        backgroundColor: '#FFF',
        height: 'calc(100% - 50px)'
    },
    statusBox: {
        float: 'right'
    },
    body: {
        position: 'absolute',
        bottom: '50px',
        left: 0,
        right: 0,
        top: 0
    },
    footer: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        height: '50px',
        boxSizing: 'border-box',
        padding: '4px 10px 4px 10px',
        backgroundColor: Colors.veryLightGrey,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
        alignItems: 'center',
        zIndex: 1
    },
    groupButtons: {
        minWidth: 85
    },
    modalContainer: {
        display: 'flex'
    },
    modalStyle: {
        width: '480px',
        display: 'block',
        overflow: 'initial',
        backgroundColor: 'transparent',
        margin: 'auto',
        boxShadow: 'none'
    },
    modalImageStyle: {
        width: '650px',
        backgroundColor: '#FFF',
        padding: '30px 0'
    },
    wrapImages: {
        width: '100%',
        height: '100%',
        textAlign: 'center',
        position: 'relative',
        zIndex: 999
    },
    imageShipment: {
        width: 'auto',
        maxWidth: '100%',
        // maxHeight: '100%',
        maxHeight: 'calc(100vh - 100px)',
        margin: 'auto',
        backgroundColor: '#FFFF'
    },
    arrowButton: {
        width: '30px',
        height: '30px',
        backgroundColor: '#000',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        top: 0,
        bottom: 0,
        margin: 'auto',
        zIndex: 10000,
        cursor: 'pointer'
    },
    arrowPrev: {
        left: 0
    },
    arrowNext: {
        right: 0
    },
    arrowIcon: {
      fontSize: '25px',
      color: '#fff'
    }
}
